export const emailUrgentOption = 'email_urgent_optin';
export const smsUrgentOptin = 'sms_urgent_optin';
export const emailBundleOptin = 'email_bundle_optin';
export const emailRecapOptin = 'email_recap_optin';
export const termsOptin = 'terms_optin';
export const slackOptin = 'slack_optin';
export const profileOptin = 'people_tab_optin';
export const unwrapitOptin = 'unwrapit_optin';
